module.exports = __webpack_public_path__ + "assets/img/cardItem03.c3fbf4e2.png";